import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  showLoading() {
    this.overlayTarget.classList.remove("d-none")
  }

  hideLoading() {
    this.overlayTarget.classList.add("d-none")
  }
}